<template>
  <div class="card-metric" :class="{ 'border-right': border }">
    <div class="card-metric__value">{{ value }} <span v-if="porcentaje">%</span></div>
    <div class="card-metric__number">{{ title }}</div>
  </div>
</template>
<script>
export default {
  props: {
    border: {
      type: Boolean,
      default: false
    },
    value: {},
    title: {},
    porcentaje: {
      type: Boolean,
      default: false
    }
  }
};
</script>
